__turbopack_context__.v({
  "item-container": "mochi-parking-tutorial-carousel-module-scss-module__bT0KdW__item-container",
  "item-content": "mochi-parking-tutorial-carousel-module-scss-module__bT0KdW__item-content",
});
